import React from 'react';
const LOGOS = [{
  src: 'https://cdn.magicpatterns.com/uploads/9uaSKJFQhbihsq9kLZhXor/tmpzzto79a1.webp',
  alt: 'Licensed Used Auto Dealer'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3kZ42CcrmCXCTwWALWZ5c4/tmp11klhr31.webp',
  alt: 'Machinery Finance Scope | Scope'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dpHh4V9taQu2FV7A7vfMKL/tmplzceszs9.webp',
  alt: 'Vibrant'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6d21gG2ajxFmM3nEn24LPK/tmpvg7p91at.webp',
  alt: 'Peoria Chamber of Commerce'
}];
export function TrustBadges() {
  return <section className="w-full py-8" style={{
    backgroundColor: '#FFFFFF',
    borderTop: '1px solid #E0E0E0',
    borderBottom: '1px solid #E0E0E0'
  }} aria-label="Trust badges and affiliations" data-id="element-251">
      <div className="max-w-5xl mx-auto px-6" data-id="element-252">
        <div className="grid grid-cols-2 md:flex md:flex-row md:justify-center md:items-center gap-8 md:gap-12 items-center justify-items-center" data-id="element-253">
          {LOGOS.map(logo => <img key={logo.alt} src={logo.src} alt={logo.alt} className="w-[100px] sm:w-[120px] object-contain" data-id="element-254" />)}
        </div>
      </div>
    </section>;
}